import {Injectable} from '@angular/core';
import {formatDateTime} from '../../common/formatters';
import {DexMdSubjectService} from '../../components/dex/dex-streaming/subjects/dex-md-subject-service';
import {DexSecuritiesSubjectService} from '../../components/dex/dex-streaming/subjects/dex-securities-subject-service';
import {Deliverable, DeliverableId} from '../../components/dex/dex-streaming/types/deliverable';
import {RefRate} from '../../components/dex/dex-streaming/types/ref-rate';
import {Tranche} from '../../components/dex/dex-streaming/types/tranche';
import {ValueWithDel} from '../../components/dex/dex-streaming/utils';

export interface DisplayDexRate {
    raw: RefRate;
    dBase: Deliverable;
    dQuote: Deliverable;
    pair: string;
    price: ValueWithDel;
    tranche?: Tranche;
    updatedAt: string;
}

@Injectable()
export class DexDisplayRateFactory {

    constructor(
        private dexSecuritiesSubjectService: DexSecuritiesSubjectService,
        private dexMdSubjectService: DexMdSubjectService
    ) {}

    public createDisplayRates(rates: RefRate[]): DisplayDexRate[] {
        return rates.map(r => this.createDisplayRate(r));
    }

    public createDisplayRate(rate: RefRate): DisplayDexRate {
        const dBase = this.dexSecuritiesSubjectService.getDeliverableById(rate.baseDeliverableId);
        const dQuote = this.dexSecuritiesSubjectService.getDeliverableById(rate.quoteDeliverableId);
        const pair = [dBase.symbol, dQuote.symbol].join('/');

        return {
            raw:   rate,
            dBase,
            dQuote,
            pair,
            price: {
                v: BigInt(rate.price),
                d: dQuote
            },
            tranche: this.getTranche(dBase.deliverableId, dQuote.deliverableId),
            updatedAt: formatDateTime(Number(BigInt(rate.timestamp) / 1000000n))
        };
    }

    private getTranche(dId1: DeliverableId, dId2: DeliverableId): Tranche | undefined {
        for (const t of this.dexMdSubjectService.trancheMapById.values()) {
            if (t.unitDeliverableId === dId1 || t.unitDeliverableId === dId2) {
                return t;
            }
        }

        return undefined;
    }

}
